<h1 class="text-center">Vaše dotazy, připomínky či návrhy rádi zodpovíme na stránkách podpory:</h1>
<h1 class="text-center"><a href="http://support.echopix.cz" target="_blank">http://support.echopix.cz</a></h1>